module.exports = __webpack_public_path__ + "static/media/img.7bc989ef.jpg";